



































import {
  Prop,
  Vue,
  Component,
} from "@/shared/vuepack";
import moment from "moment";
import { Reimbursement, ReimbursementStatusType } from "@/shared/types";
import Pill from "@/shared/components/ui/Pill.vue";
import CurrencyAmount from "@/shared/components/ui/CurrencyAmount.vue";

@Component({
  components: {
    Pill,
    CurrencyAmount,
  }
})
export default class ReimbursementHistoryRow extends Vue {

  @Prop()
  reimbursement: Reimbursement;

  get formattedDate (): string {
    return moment(this.reimbursement.createdDate).format("MMM D, YYYY");
  }

  getDescription (description): string {
    return description ? description : "Reimbursement";
  }

  getStatusTypeText (status: ReimbursementStatusType): string {
    switch (status) {
      case ReimbursementStatusType.InProcess: {
        return "In Process";
      }
      case ReimbursementStatusType.Failed: {
        return "Failed";
      }
      case ReimbursementStatusType.None:
      case ReimbursementStatusType.Pending: {
        return "Pending";
      }
      case ReimbursementStatusType.Complete: {
        return "Complete";
      }
    }
  }
}
